import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { TableComponent } from '@siemens/component-lib';
import { AdminReportTemplateListComponent } from './components/admin-report-template-list/admin-report-template-list.component';
import { AdminReportTemplateComponent } from './admin-report-template.component';

const compLibComponents = [TableComponent];

@NgModule({
    declarations: [AdminReportTemplateComponent, AdminReportTemplateListComponent],
    exports: [AdminReportTemplateComponent, AdminReportTemplateListComponent],
    imports: [CommonModule, SharedModule, ...compLibComponents]
})
export class AdminReportTemplateModule {}
